import { render, staticRenderFns } from "./ClinicXmlRecipes.vue?vue&type=template&id=4c366888"
import script from "./ClinicXmlRecipes.vue?vue&type=script&lang=js"
export * from "./ClinicXmlRecipes.vue?vue&type=script&lang=js"
import style0 from "./ClinicXmlRecipes.vue?vue&type=style&index=0&id=4c366888&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports